import resolve from '../../../../../modules/api/resolve';
import { apiPost, generateFormData } from '../../../../../modules/apiHelper';

export default {
  async addAllUsersToProgram(context, data) {
    const formData = generateFormData(data);

    const response = await resolve(apiPost('ad_user_al', formData, 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async addUserToProgram(context, data) {
    const formData = generateFormData(data);

    const response = await resolve(apiPost('ad_user', formData, 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async requestUserToJoinProgram(context, data) {
    const formData = generateFormData(data);

    const response = await resolve(apiPost('join_request_user', formData, 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async requestAllUsersToJoinProgram(context, data) {
    const formData = generateFormData(data);

    const response = await resolve(apiPost('join_request_al', formData, 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async removeUserFromProgram(context, data) {
    const formData = generateFormData(data);

    const response = await resolve(apiPost('rem_user', formData, 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async getProgramUsers(context, data) {
    const formData = generateFormData(data);

    const response = await resolve(apiPost('prog_users', formData, 79)).then(async (res) => {
      if (!res) return false;

      const enrichUserData = async (dataArray) => {
        const enrichedUsers = await Promise.all(
          dataArray.map(async ([userPromise, status]) => {
            const user = await userPromise;
            return {
              ...user,
              programStatus: status,
            }; // Add status to the resolved user object
          }),
        );
        return enrichedUsers;
      };

      // load users data asynchronously
      const usersDataReq = [];
      (res.prog_users || []).forEach(({ userid, status }) => {
        usersDataReq.push([context.dispatch('getUserData', userid), status]);
      });

      return enrichUserData(usersDataReq);
    });

    return response;
  },

  async getUsersNotInProgram(context, data) {
    const users = await Promise.all([
      context.dispatch('getAccounts', ['mentor', 'verified', data.companyId], { root: true }),
      context.dispatch('getAccounts', ['mentee', 'verified', data.companyId], { root: true }),
      resolve(apiPost('prog_users', generateFormData({ progid: data.programId }), 79)),
      context.dispatch('getRequestedUsers', { progid: data.programId }),
    ]).then(([mentors, mentees, programUsers, requestedUsers]) => {
      if (!programUsers) return [];

      return [...mentors, ...mentees].reduce((prevUsers, user) => {
        const userInProgram = (programUsers.prog_users || []).find((u) => Number(u.userid) === Number(user.id));
        const userIsRequested = (requestedUsers || []).find((u) => Number(u.userid) === Number(user.id));

        if (!userInProgram) {
          prevUsers.push({ ...user, requested: !!userIsRequested });
        }

        return prevUsers;
      }, []);
    });

    return users;
  },

  async getRequestList(context, data) {
    const [
      requestedUsers,
      acceptedUsers,
      declinedUsers,
    ] = await Promise.all([
      context.dispatch('getRequestedUsers', data),
      context.dispatch('getAcceptedUsers', data),
      context.dispatch('getDeclinedUsers', data),
    ]);

    // remove duplicate users
    const unansweredUserRequests = requestedUsers.filter((userRequest) => {
      const foundInAcceptedRequests = acceptedUsers.find((u) => u.userid === userRequest.userid);
      const foundInDeclinedRequests = declinedUsers.find((u) => u.userid === userRequest.userid);

      if (!foundInAcceptedRequests && !foundInDeclinedRequests) return userRequest;
      return null;
    });

    // load users data asynchronously
    const usersDataReq = [];
    [...acceptedUsers, ...declinedUsers, ...unansweredUserRequests].forEach(({ userid }) => {
      usersDataReq.push(context.dispatch('getUserData', userid));
    });

    return Promise.all(usersDataReq);
  },

  async getRequestsStats(context, data) {
    const [
      requestedUsers,
      acceptedUsers,
      declinedUsers,
    ] = await Promise.all([
      context.dispatch('getRequestedUsers', data),
      context.dispatch('getAcceptedUsers', data),
      context.dispatch('getDeclinedUsers', data),
    ]);

    // remove duplicate users
    const unansweredUserRequests = requestedUsers.filter((userRequest) => {
      const foundInAcceptedRequests = acceptedUsers.find((u) => u.userid === userRequest.userid);
      const foundInDeclinedRequests = declinedUsers.find((u) => u.userid === userRequest.userid);

      if (!foundInAcceptedRequests && !foundInDeclinedRequests) return userRequest;
      return null;
    });

    return {
      unansweredRequests: unansweredUserRequests.length,
      acceptedRequests: acceptedUsers.length,
      declinedRequests: declinedUsers.length,
    };
  },

  async getRequestedUsers(context, data) {
    const formData = generateFormData(data);

    const response = await resolve(apiPost('join_req_list', formData, 79)).then(async (res) => {
      if (!res) return false;

      return res.join_req_list || [];
    });

    return response;
  },

  async getAcceptedUsers(context, data) {
    const formData = generateFormData(data);

    const response = await resolve(apiPost('accept_list', formData, 79)).then(async (res) => {
      if (!res) return false;

      return res.accept_list || [];
    });

    return response;
  },

  async getDeclinedUsers(context, data) {
    const formData = generateFormData(data);

    const response = await resolve(apiPost('decline_list', formData, 79)).then(async (res) => {
      if (!res) return false;

      return res.decline_list || [];
    });

    return response;
  },

  async activateUserToProgram(context, data) {
    const formData = generateFormData(data);

    const response = await resolve(apiPost('act_user', formData, 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async deactivateUserToProgram(context, data) {
    const formData = generateFormData(data);

    const response = await resolve(apiPost('dev_user', formData, 79)).then(async (res) => {
      if (!res) return false;

      return true;
    });

    return response;
  },

  async getUserPrograms(context, userId) {
    const userPrograms = await resolve(apiPost('prog_user_list', generateFormData({
      userid: userId,
    }), 79));

    if (!userPrograms) return false;

    // load the programs' details
    const programRequests = [];

    userPrograms.prog_user_list.forEach((userProgram) => {
      const request = context.dispatch('getProgram', [userProgram.progid, false]);
      programRequests.push(request);
    });

    const response = await Promise.all(programRequests);

    return response.filter((res) => !!res);
  },
};
